import { API_ROOT, logApiError } from './api';
import axios from 'axios';

export default {
    namespaced: true,
    actions: {
        async getVideoDescription({ dispatch, rootGetters }, payload) {
            try {
                const response = await axios.post(
                    `${API_ROOT}/material-participation/video-description/`,
                    payload,
                    rootGetters.axiosConfig,
                );
                return response['data'];
            } catch (e) {
                logApiError(e, dispatch);
                return false;
            }
        },
    },
};
